var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[(_vm.className + "__side"), (_vm.className + "__" + _vm.type)],style:(_vm.style)},[_vm._t("header"),_c('div',{class:(_vm.className + "__side__body")},[_vm._t("default",null,{"data":_vm.data})],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }